import React from "react";
import { useNavigate } from "react-router-dom";
import SmartSuggestInput from "@/components/SmartSuggestInput";
import { Select } from "@/components/UI";
import { CUSTOMER_TYPES } from "@/lib/customers";

export function CustomerFilters({ rows, filters, onChange }) {
  const nav = useNavigate();
  const set = (k, v) => onChange({ ...filters, [k]: v });
  return (
    <div className="grid grid-cols-1 md:grid-cols-[1fr_200px_160px] gap-3 mb-4" data-testid="customer-filters">
      <SmartSuggestInput
        label="Ara"
        value={filters.q}
        items={rows}
        displayField="legal_name"
        secondaryField={(c) => [c.code, c.contact_name, c.phone].filter(Boolean).join(" · ")}
        searchAccessor={(c) => [c.code, c.contact_name, c.phone, c.email]}
        placeholder="Firma, yetkili, telefon veya kod…"
        onChange={({ value, item }) => (item ? nav(`/customers/${item.id}`) : set("q", value))}
        data-testid="cust-filter-search"
      />
      <Select label="Müşteri Tipi" value={filters.type} onChange={(e) => set("type", e.target.value)} data-testid="cust-filter-type">
        <option value="">Tümü</option>
        {CUSTOMER_TYPES.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
      </Select>
      <Select label="Durum" value={filters.status} onChange={(e) => set("status", e.target.value)} data-testid="cust-filter-status">
        <option value="">Tümü</option>
        <option value="active">Aktif</option>
        <option value="inactive">Pasif</option>
      </Select>
    </div>
  );
}
